module.exports = __webpack_public_path__ + "static/media/icon_remaketype.bbfcae7d.svg";